import ModelArticle from './ModelArticle';
import { keywordSets } from '../PageSeo';
import { vehiclePrices } from '../vehiclePrices';
import heroDesktop from '../images/z9gt/hero-desktop.jpg';
import highlightFront from '../images/z9gt/highlight-front.jpg';
import highlightSide from '../images/z9gt/highlight-side.jpg';
import highlightRear from '../images/z9gt/highlight-rear.jpg';
import highlightHero from '../images/z9gt/highlight-hero.jpg';
import heroMobile from '../images/z9gt/hero-mobile.jpg';
import flashCharging from '../images/z9gt/flash-charging.jpg';
import pricePoster from '../images/z9gt/z9gt-harga.jpg';

const PRICE = vehiclePrices.z9gt[0];

export const z9gtArticleMeta = {
  slug: 'danza-z9-gt-indonesia-shooting-brake-listrik',
  title: `Danza Z9 GT Indonesia: Shooting Brake Listrik 1.156 PS, Harga ${PRICE.price}`,
  description:
    'Ulasan Danza Z9 GT untuk Indonesia: platform e³ tiga motor 1.156 PS, 0-100 km/jam 2,7 detik, rear wheel steering radius putar 4,62 m, Blade Battery 2.0 dengan Flash Charging, dan harga Rp2.250.000.000 OTR Jakarta.',
  image: highlightHero,
  contentLength: '1050 kata',
};

const article = {
  slug: z9gtArticleMeta.slug,
  metaTitle: z9gtArticleMeta.title,
  metaDescription: z9gtArticleMeta.description,
  keywords: [
    ...keywordSets.z9gt,
    ...keywordSets.danza,
    ...keywordSets.localDealer,
    'Danza Z9 GT review',
    'Danza Z9 GT vs Porsche Panamera',
    'mobil listrik tercepat Indonesia',
  ],
  datePublished: '2026-11-01',
  heroImage: heroDesktop,
  heroAlt: 'Danza Z9 GT Fjord Green, shooting brake listrik premium',
  eyebrow: 'Danza Z9 GT · Technology Drives Elegance',
  heroTitle: 'Danza Z9 GT: shooting brake listrik 1.156 PS yang tetap nyaman untuk harian',
  heroText: `Danza, brand premium BYD yang sebelumnya dikenal sebagai Denza, menghadirkan Z9 GT dengan tiga motor listrik, kemudi roda belakang, suspensi udara DiSus-A, dan Flash Charging 9 menit. Harganya ${PRICE.price} OTR Jakarta dan unitnya tersedia di BYD BSD Serpong.`,
  modelPath: '/jelajahi-z9gt',
  modelLabel: 'Lihat halaman Danza Z9 GT',
  waMessage: `Halo Junius, saya baca artikel Danza Z9 GT dan tertarik dengan unit seharga ${PRICE.price}. Mohon info ketersediaan warna, promo, dan jadwal test drive.`,
  quickSpecs: [
    { label: 'Harga OTR Jakarta', value: 'Rp2,25 miliar' },
    { label: 'Tenaga sistem', value: '1.156 PS' },
    { label: '0-100 km/jam', value: '2,7 detik' },
    { label: 'Jarak tempuh NEDC', value: '701 km' },
    { label: 'Flash Charging', value: '10-97% 9 menit' },
  ],
  sections: [
    {
      title: 'Denza kini bernama Danza, dan Z9 GT adalah flagship-nya',
      paragraphs: [
        'Di Indonesia, brand premium BYD resmi memakai nama Danza, menggantikan nama Denza yang dipakai sebelumnya. Produk, teknologi, garansi, dan layanan purnajualnya tetap sama, hanya identitasnya yang disesuaikan untuk pasar Indonesia. Danza Z9 GT adalah model paling bertenaga di jajaran ini dan diposisikan sebagai sedan GT listrik mewah yang bersaing dengan sedan performa Eropa.',
        'Bentuknya shooting brake: sedan dengan atap memanjang ke belakang sehingga punya ruang bagasi 495 liter yang bisa diperluas menjadi 1.680 liter, ditambah bagasi depan 53 liter. Proporsinya mengikuti golden ratio dengan rasio roda terhadap sumbu di atas 3:1, garis pinggang berbentuk Z yang menjadi tanda tangan desainnya, dan dua spoiler belakang, satu berongga melayang dan satu aktif yang naik-turun otomatis.',
      ],
    },
    {
      title: 'Platform e³: tiga motor, kemudi roda belakang, satu otak',
      paragraphs: [
        'Z9 GT dibangun di atas platform e³ dengan satu motor AC asynchronous di depan dan dua motor permanent magnet independen di belakang. Totalnya 1.156 PS atau 850 kW dengan torsi 1.210 Nm yang bisa dilepas instan lewat tombol BOOST hingga 20 detik. Akselerasi 0-100 km/jam ditempuh 2,7 detik, kecepatan maksimum 240 km/jam.',
        'Tenaga sebesar itu tetap mudah dikendalikan berkat rear wheel steering independen. Radius putarnya hanya 4,62 meter, paling kecil di kelasnya, dan mode Crab Walk menggerakkan keempat roda searah hingga 15 derajat untuk keluar dari parkir sempit. Vehicle Motion Control mengoordinasikan kemudi, rem, suspensi, dan tenaga, teruji pada moose test 93,6 km/jam dan tetap stabil saat pecah ban di 180 km/jam. Suspensi udara DiSus-A dual chamber mengatur ketinggian 100 sampai 145 mm secara otomatis.',
      ],
    },
    {
      title: 'Blade Battery 2.0 dan Flash Charging: penuh dalam 9 menit',
      paragraphs: [
        'Baterai Blade generasi kedua berkapasitas 122,49 kWh memakai arsitektur 1000 V dan menyatu langsung dengan bodi lewat teknologi Cell-to-Body. Densitas energinya 5 persen lebih tinggi dari generasi pertama dan lolos uji tusuk paku tanpa terbakar, bahkan saat sedang diisi cepat. Jarak tempuhnya 701 km NEDC.',
        'Dengan BYD Flash Charger, pengisian 10 ke 70 persen memakan waktu sekitar 5 menit dan 10 ke 97 persen sekitar 9 menit, secepat mengisi bensin. Sepuluh Flash Charger pertama di Indonesia tersedia di dealer Danza. Pengisian AC rumahan mendukung hingga 11 kW, dan fitur V2L menyediakan daya hingga 4 kW untuk perangkat luar.',
      ],
    },
    {
      title: 'Kabin: tiga layar 2.5K, Devialet 20 speaker, dan kulkas',
      paragraphs: [
        'Kabin Z9 GT memadukan atap knitted velvet, kulit asli, dan ornamen kayu alami. Ada tiga layar 2.5K: panel instrumen 13,2 inci, head unit 17,3 inci, dan layar co-pilot 13,2 inci untuk penumpang depan, ditambah AR-HUD proyeksi 50 inci, spion tengah digital 9,1 inci, dan layar AC 6 inci untuk penumpang belakang. Google Maps, Google Assistant, dan Google Play sudah terintegrasi.',
        'Sistem audio Devialet 20 speaker dipadu ambient light multi-warna. Kursi depan punya pengaturan 8 arah plus lumbar 4 arah, pemanas, ventilasi, pijat, dan side bolster aktif yang menopang tubuh saat menikung. Kursi belakang elektrik dengan leg rest, Boss Key untuk menggeser kursi depan, armrest dengan wireless charging 50 W, kulkas 4 liter yang bisa mendinginkan hingga minus 6 derajat atau menghangatkan hingga 50 derajat, dan kaca rias lipat berlampu. Keempat pintu elektrik soft-close dengan empat radar pendeteksi rintangan.',
      ],
    },
    {
      title: 'Harga Danza Z9 GT dan cara memesan',
      paragraphs: [
        `Danza Z9 GT dijual ${PRICE.price} OTR Jakarta untuk varian three-motor AWD dengan empat pilihan warna: Fjord Green, Obsidian Black, Snow White, dan Porcelain Blue, serta tiga pilihan interior. Tiga hal perlu diketahui calon pembeli di Indonesia: sensor LiDAR di bagian depan sudah terpasang tetapi fitur mengemudi otonomnya menunggu regulasi, sensor pembuka pintu otomatis tidak tersedia di unit Indonesia, dan parkir otomatis tetap memerlukan pengawasan pengemudi.`,
        'Untuk booking unit, simulasi pembiayaan, atau jadwal test drive, hubungi Junius di BYD BSD Serpong. Unit bisa dilihat langsung di showroom BYD Arista BSD City.',
      ],
    },
  ],
  specTitle: 'Spesifikasi Danza Z9 GT Standard (AWD)',
  specRows: [
    ['Harga OTR Jakarta', PRICE.price],
    ['Dimensi (P x L x T)', '5.180 x 1.990 x 1.490 mm'],
    ['Wheelbase', '3.125 mm'],
    ['Radius putar minimum', '4,62 m'],
    ['Konfigurasi motor', 'Three-Motor (1 depan + 2 belakang), AWD'],
    ['Tenaga sistem maksimum', '1.156 PS / 850 kW'],
    ['Torsi sistem maksimum', '1.210 Nm'],
    ['Akselerasi 0-100 km/jam', '2,7 detik'],
    ['Kecepatan maksimum', '240 km/jam'],
    ['Baterai', 'Blade Battery 2.0 (LFP) + CTB, 122,49 kWh, 1000 V'],
    ['Jarak tempuh NEDC', '701 km'],
    ['Pengisian DC', 'Flash Charging, 10-97% sekitar 9 menit'],
    ['Pengisian AC', '11 kW'],
    ['V2L', 'Hingga 4 kW'],
    ['Bagasi depan / belakang', '53 L / 495-1.680 L'],
    ['Velg', '20 inci multi-spoke, ban 255/45 R20'],
    ['Airbag', '9'],
  ],
  galleryTitle: 'Desain Danza Z9 GT',
  gallery: [
    { src: highlightFront, ratio: 52, alt: 'Danza Z9 GT tampak depan dengan lampu dual line', title: 'Dual Line Front Light', text: 'Lampu depan dua garis dengan logo Danza di tengah.' },
    { src: highlightSide, ratio: 52, alt: 'Danza Z9 GT tampak samping, garis pinggang Z', title: 'Z-Shape Waistline', text: 'Garis pinggang berbentuk Z, tanda tangan desain Z9 GT.' },
    { src: highlightRear, ratio: 52, alt: 'Lampu belakang Danza Z9 GT bermotif jam pasir', title: 'Time Hourglass Taillight', text: 'Lampu belakang selebar bodi dengan dua spoiler.' },
    { src: flashCharging, ratio: 112, alt: 'BYD Flash Charging: siap jalan 5 menit, penuh 9 menit', title: 'Flash Charging', text: '10-70% sekitar 5 menit, 10-97% sekitar 9 menit.' },
    { src: pricePoster, ratio: 112, alt: 'Harga Danza Z9 GT Rp2.250.000.000 OTR Jakarta', title: 'Harga resmi', text: `${PRICE.price} OTR Jakarta, varian three-motor AWD.` },
    { src: heroMobile, ratio: 112, alt: 'Danza Z9 GT Fjord Green melaju di jalan kota', title: 'Fjord Green', text: 'Warna ikonik Z9 GT dengan velg 20 inci multi-spoke.' },
  ],
  faqs: [
    {
      q: 'Apakah Danza sama dengan Denza?',
      a: 'Ya. Danza adalah nama resmi brand premium BYD di Indonesia, menggantikan nama Denza. Produk, teknologi, garansi, dan layanan purnajual tetap sama.',
    },
    {
      q: 'Berapa harga Danza Z9 GT di Indonesia?',
      a: `Danza Z9 GT dijual ${PRICE.price} OTR Jakarta untuk varian three-motor AWD. Hubungi Junius untuk promo dan simulasi pembiayaan.`,
    },
    {
      q: 'Berapa lama pengisian daya Danza Z9 GT?',
      a: 'Dengan BYD Flash Charger, 10-70% sekitar 5 menit dan 10-97% sekitar 9 menit. Pengisian AC di rumah mendukung hingga 11 kW.',
    },
    {
      q: 'Apakah Z9 GT bisa dipakai harian di Jakarta?',
      a: 'Bisa. Radius putar 4,62 meter dan mode Crab Walk memudahkan manuver di jalan sempit, suspensi udara DiSus-A menjaga kenyamanan, dan jarak tempuh 701 km NEDC cukup untuk pemakaian seminggu.',
    },
    {
      q: 'Apakah fitur LiDAR Danza Z9 GT sudah aktif di Indonesia?',
      a: 'Sensor LiDAR sudah terpasang, tetapi fitur mengemudi otonomnya menunggu regulasi di Indonesia sebelum diaktifkan.',
    },
  ],
  related: [
    { label: 'Halaman model Danza Z9 GT: pilihan warna dan spesifikasi lengkap', to: '/jelajahi-z9gt' },
    { label: 'Danza D9 NIK 2026 generasi kedua: apa yang baru', to: '/blog/danza-d9-nik-2026-generasi-kedua' },
    { label: 'BYD Sealion 7: SUV listrik sporty', to: '/blog/sealion-7-suv-listrik-sporty' },
    { label: 'Daftar harga BYD dan Danza terbaru', to: '/pricing' },
  ],
  ctaTitle: 'Rasakan Danza Z9 GT di BYD BSD Serpong',
  ctaText:
    'Hubungi Junius untuk booking unit, cek ketersediaan warna, promo, simulasi pembiayaan, dan jadwal test drive Danza Z9 GT.',
  product: {
    name: 'Danza Z9 GT',
    alternateName: 'Denza Z9 GT',
    description: 'Shooting brake listrik premium Danza Z9 GT three-motor AWD 1.156 PS dengan Blade Battery 2.0 dan Flash Charging.',
    price: PRICE.priceValue,
  },
};

function Z9GTArticle() {
  return <ModelArticle article={article} />;
}

export default Z9GTArticle;
